import React from "react";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Select,
  Space,
} from "antd";
import { BOM } from "../../../../services/definedMethod";
import appLabel from "../../../../config/appLabel";

const AddingForm = (props) => {
  const { fields, remove, inputName, glAccountList } = props;

  return (
    <>
      {fields.map(({ key, name, ...restField }) => (
        <Space
          key={key}
          style={{
            display: "flex",
            marginBottom: 8,
          }}
          align="baseline"
        >
          <Form.Item
            {...restField}
            name={[name, appLabel.glAccountId]}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(inputName),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(inputName)}
              style={{ width: "30vh" }}
              options={glAccountList}
              showSearch
              allowClear
            />
          </Form.Item>
          <Form.Item
            {...restField}
            name={[name, "amount"]}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(appLabel.amount),
              },
            ]}
          >
            <InputNumber
              style={{ width: "30vh" }}
              placeholder={BOM.handlePlaceholderMsg(
                appLabel.amount,
                appLabel.pleaseEnter,
              )}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => remove(name)}
            okText="OK"
            cancelText="Cancel"
            okButtonProps={{
              style: {
                backgroundColor: "#15CCAE",
                color: "white",
                height: "15%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              },
            }}
            cancelButtonProps={{
              style: {
                height: "15%",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              },
            }}
          >
            <Button
              height="15%"
              width="15%"
              style={{ borderRadius: "50%" }}
              type="text"
              icon={<DeleteOutlined />}
              className="of-primaryBtnColor"
            />
          </Popconfirm>
        </Space>
      ))}
    </>
  );
};

const AffectGlForm = (props) => {
  const { formName, glAccountList, labelParam } = props;
  const [form] = Form.useForm();

  return (
    <Form.List name={formName?.toLowerCase()}>
      {(fields, { add, remove }) => (
        <>
          <Button
            onClick={() => add()}
            type="primary"
            icon={<PlusOutlined />}
            style={{
              backgroundColor: "#15CCAE",
              color: "white",
              width: "15vh",
              marginBottom: 20,
            }}
            className="of-primaryBtnColor"
          >
            {labelParam}
          </Button>
          <AddingForm
            fields={fields}
            add={add}
            remove={remove}
            inputName={formName}
            glAccountList={glAccountList}
          />
        </>
      )}
    </Form.List>
  );
};

export default AffectGlForm;
